import { connect } from 'react-redux'
import AlertModalView from 'support/popup_dialogs/views/components/alert_modal_view/AlertModalView'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import Navigation from 'support/navigation'
import i18n from 'support/i18n'

const mapStateToProps = (props,Ownprops) => {
  // console.log(":props===",props,Ownprops)
  return{
    title: i18n.t('CONFIRMATION_MESSAGE'),
    description: Ownprops.description,
    mainButtonText: i18n.t('ACCEPT'),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {response} = ownProps
  // console.log("challenge response==>",response, response.items[0]?.id)
  return {
    mainButtonAction: () => {
      dispatch(hideDialog())
      dispatch(Navigation.navigateToChallengeDetail(response?.items[0]?.id))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertModalView)
